import { usePagination } from '@/composables/usePagination';
import { data } from './impressionHistories';

export default {
  get({ params }) {
    const { paginate } = usePagination(data, 10);
    const response = { ...paginate(params.page) };
    return [200, response];

    // error: タイムアウト
    // return [408, { message: 'タイムアウトしました' }];
  }
};
